import { createSlice } from '@reduxjs/toolkit';

export const opportunityDetailSlice = createSlice({
  name: 'opportunityDetail',
  initialState: {
    data: {},
  },
  reducers: {

    getData: () => {},
    getDataSuccess: (state, action) => {
      state.data = action.payload;
    },
    saveData: (state) => {
      state.isSaveSuccess = false;
    },
    saveDataSuccess: (state, action) => {
      state.isSaveSuccess = true;
      state.saveId = action.payload;
    },
    getOrderDetails: () => {},
    getOrderDetailsSuccess: (state, action) => {
      state.details = action.payload;
    },
    resetFlg: (state) => {
      state.isSaveSuccess = false;
    },
  },
});

export const opportunityDetailActions = opportunityDetailSlice.actions;

export default opportunityDetailSlice.reducer;
